import React from "react";
import { motion } from "framer-motion";
import { FiExternalLink, FiGithub } from "react-icons/fi";
import projects from "../data/projects.json";

function Projects() {

    return (
        <section id="projects" className="px-6 py-20 bg-[#e3dac9]">
           <h2 className="text-3xl font-bold text-center mb-12 relative text-black">
              My Projects
              <div className="w-24 h-1 bg-[#964b00] mx-auto mt-2"></div>
           </h2>
          <div className="grid md:grid-cols-3 gap-8">
            {projects.map((project, index) => (
            <motion.a
              key={index}
              href={project.link}
              className="bg-white rounded-xl shadow-md hover:shadow-xl transition p-6 flex flex-col justify-between"
              whileHover={{ scale: 1.02 }}
            >
              <img src={project.image} alt={project.title} className="w-full h-48 object-cover rounded-md mb-4"/>

              <div>
                <h3 className="text-xl font-semibold mb-2 text-black">{project.title}</h3>
                <p className="text-gray-700 mb-4">{project.desc}</p>

                <div className="flex flex-wrap gap-2 mb-4">
                   {project.tech.map((tech,i) => (
                    <span 
                      key={i}
                      className="bg-[#c19a6b] text-[#321414] text-sm font-medium px-3 py-1 rounded-full"
                    >
                        {tech}
                      </span>
                    ))}
                </div>
              </div>
             
              <div className="flex items-center gap-6 mt-4">
                <a 
                  href={project.link2}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-1 text-gray-800 hover:text-black">
                    <FiExternalLink /> Live Demo
                </a>
                <a
                  href={project.link1}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-1 text-gray-800 hover:text-black"
                >
                    <FiGithub /> Source Code
                </a>
              </div>
              
            </motion.a>
          ))}
        </div>
        <div className="flex justify-center mt-8">
            <motion.a
              href="https://github.com/WeerasingheN-T"
              className="bg-transparent hover:bg-[#c19a6b] text-black font-semibold hover:text-black inline-block px-12 py-3 border border-[#987654] hover:border-transparent rounded-full"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.6, duration: 1 }}>
                View All Projects
            </motion.a>
        </div>
        
      </section>
    )
}

export default Projects;